import type { TenantConfig } from '@/types/index';

/**
 * Alignment Health Plan — first real tenant per Cycle 1 directive.
 *
 * Per spec §0 Tenants: Alignment first, LA Health later.
 * Per spec §15: 3 programs initially — BP CUFFS, FOBT, A1c & KED.
 * Per spec §10 ingestion: legacy data sources include
 *   `25.07.17, 1, BQX, Alignment SMS Coding (1).xlsx` and `communications.csv`.
 *
 * tenant_type=production gates demo_operator RBAC.
 */
export const alignmentTenant: TenantConfig = {
  tenantId: 'alignment',
  tenantName: 'Alignment Health Plan',
  tenantType: 'production',
  programs: ['25fobt', '25a1c', '25ked', '25a1cked', '26fobt'],
  brandTokens: {
    primaryHex: '#00579c',
    accentHex: '#008f60',
    logoUrl: '/branding/alignment/logo.svg',
    fontFamily: "'Inter Variable', Inter, system-ui, sans-serif",
  },
  freshness: { kind: 'fresh', snapshotDate: new Date().toISOString().slice(0, 10) },
};
